
<!--
 * @Description: 学生请假记录 添加
 * @Author: ZSC
 * @Date: 2023-04-24 15:52:34.577
 * @LastEditors: PF
 * @LastEditTime: 2024-07-10 11:50:36
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="请假班级">
              <el-select v-model="banjiid" class="m-2" placeholder="请选择班级" @change="setxvesheng" filterable>
                <el-option v-for="item in banjilist" :key="item.id" :label="item.xzbmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请假学生" prop="xsid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xsid" class="m-2" placeholder="请选择学生" filterable>
                <el-option v-for="item in xveshenglist" :key="item.id" :label="item.xm" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请假类型" prop="qjlxid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.qjlxid" class="m-2" placeholder="请选择请假类型" filterable>
                <el-option v-for="item in qingjialeixinglist" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否离校" prop="sflx" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-radio-group v-model="ruleForm.sflx">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请假时间" prop="" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-col :span="12">
                <el-date-picker v-model="ruleForm.qjkssj" type="datetime" class="mr5" placeholder="开始时间" value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm" @change="inputxs" />
              </el-col>
              <el-col :span="12">
                <el-date-picker v-model="ruleForm.qjjssj" type="datetime" class="ml5" placeholder="结束时间" value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm" @change="inputxs" />
              </el-col>

            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请假天数" prop="qjts" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input-number v-model="ruleForm.qjts" :min="0" :precision="1" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请假原因" prop="qjyy" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.qjyy" :rows="4" type="textarea" placeholder="请假原因" resize="none" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit(0)">存草稿</el-button>
            <el-button type="primary" @click="submit(1)">提交</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import moment from 'moment'
const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const qingjialeixinglist = ref() // 学生请假类型
const banjiid = ref() // 班级id
const selectxqid = ref() // 学期
const xveshenglist = ref([]) // 学生数据
const banjilist = ref() // 班级数据
// 计算天数
const inputxs = () => {
  const dateDiff =
    new Date(ruleForm.value.qjjssj).getTime() -
    new Date(ruleForm.value.qjkssj).getTime() // 时间差的毫秒数

  const dayDiff = dateDiff / (24 * 3600 * 1000) // 计算出相差天数
  if (Number(dayDiff) < 1) {
    ruleForm.value.qjts = 0.5
  } else {
    ruleForm.value.qjts = Math.floor(dayDiff)
  }
}
const huoqvdangqianriqi = () => {
  ruleForm.value.qjkssj = getDate('YYYY', 'MM', 'DD') + ' 08:00'
  ruleForm.value.qjjssj = moment(ruleForm.value.qjjssj).add(1, 'd').format('YYYY-MM-DD') + ' 09:00'
  inputxs()
}

// 班级发生了改变
const setxvesheng = (e) => {
  getbanjixveshenglist()
  ruleForm.value.xsid = ''
}
const allXq = ref()
// 获取学期
const initSelectList = async () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: allXq,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          selectxqid.value = element.id
          getdengluren()
        }
      })
    }
  })
}
// 查询班级学生
const getbanjixveshenglist = () => {
  loadSelect({
    url: '/api/v2/pdp/xuesheng/banjixuesheng',
    data: xveshenglist,
    order: 'xh',
    parms: { bjid: banjiid.value },
    sort: 'asc'
  })
}
// 查询当前登陆人的班级
const getdengluren = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/banzhuren',
    data: banjilist,
    order: 'xzbdm',
    parms: { xqid: selectxqid.value },
    sort: 'asc',
    loadSuccess: function (res) {
      banjiid.value = res.data[0].id
      getbanjixveshenglist()
    }
  })
}

const submit = async (e) => {
  ruleForm.value.zt = e
  submitForm({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/banzhuren',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      loadZiDianSelect('学生请假类型', qingjialeixinglist)
      initSelectList()
      huoqvdangqianriqi()
    }
  },
  { deep: true, immediate: true }
)
</script>
